import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { TokenService } from "../../services/token.service";
import { UserRole } from "../../types/user";
import { LoadingSpinner } from "../LoadingSpinner";

interface RoleBasedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

export const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const { userProfile, loadingProfile } = useUser();
  const isInternalTokenValid: boolean = TokenService.isInternalTokenValid();

  const hasRequiredRole: boolean =
    !!userProfile?.role && allowedRoles.includes(userProfile.role);

  if ((isInternalTokenValid || loadingProfile) && !userProfile) {
    return <LoadingSpinner fullScreen size="large" message="Loading..." />;
  }

  if (hasRequiredRole) {
    return <>{children}</>;
  }

  // User doesn't have required role - redirect to a sensible default per role
  let fallbackPath = "/dashboard";
  if (
    userProfile?.role === UserRole.COORDINATOR ||
    userProfile?.role === UserRole.VOLUNTEER
  ) {
    fallbackPath = "/tasks";
  }

  return <Navigate to={fallbackPath} replace />;
};
